import React, { useEffect, useState } from "react";
import { Row } from "reactstrap";
import PageHeader from "../../../components/PageHeader";
import { ColCard } from "../../../components/ContentLayout";
import TaxAccountantInfo from "../../../components/TaxPortal/Settings/TaxAccountantInfo";
import TaxAccountantHometaxCert from "../../../components/TaxPortal/Settings/TaxAccountantHometaxCert";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import TaxAccountSubHometaxList from "../../../components/TaxPortal/Settings/TaxAccountSubHometaxList";
import { viewLoading } from "../../../utils/loading";
import { getTaxAccountantFinancesAccounts } from "../../../apis/tax-accountant-finance/auth";
import { FINANCE_SCRAPING_STATE } from "../../../constants/SCRAPING_DATA";
const TaxportalSettingsHometax = () => {

  const history = useHistory();

  const [activeTab, setActiveTab] = useState("hometax_setting");

  const _setActiveTab = (value) => {
    history.push(`/tax-portal/settings/hometax?tab=${value}`);
  };

  const tabList = [
    {
      label: "기본정보",
      action: _setActiveTab,
      value: "hometax_setting",
    },
    {
      label: "부서사용자",
      action: _setActiveTab,
      value: "hometax_employee_setting",
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location, tabList]);

  const [headerButtons, setHeaderButtons] = useState([])



  const [accountInfo, setAccountInfo] = useState({});
  const [state, setState] = useState({});
  useEffect(() => {
    getAccount();
  }, []);
  // certName
  // expireDate
  const getAccount = () => {
    viewLoading(true);
    getTaxAccountantFinancesAccounts("tax-accountant-hometax")
      .then((res) => {
        res = res.data.accounts.find((account) => account.orgCd === "tax-accountant-hometax");
        const state = FINANCE_SCRAPING_STATE.find(state => state.value === res?.financeScrapings[0]?.state);
        setState(state);
        setAccountInfo(res);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => viewLoading(false));
  };


  return (
    <>
      <PageHeader title={`홈택스 설정`}
        activeTab={activeTab}
        tabList={tabList}
        buttons={headerButtons}
      />
      <div className="automatic-setting" style={{ maxWidth: '800px' }}>
        <section id="section-one">
          {activeTab === "hometax_setting" && <>
            <Row>
              <ColCard>
                <TaxAccountantInfo />
              </ColCard>
            </Row>
            <TaxAccountantHometaxCert
              accountInfo={accountInfo}
              state={state}
              getAccount={getAccount} setHeaderButtons={setHeaderButtons}
            />
          </>}
          {activeTab === "hometax_employee_setting" &&
            <TaxAccountSubHometaxList
              setHeaderButtons={setHeaderButtons}
              accountInfo={accountInfo}
              state={state}
            />}


        </section>
      </div>
    </>
  );
};

export default TaxportalSettingsHometax;

// 카테고리 활성 비활성
// 휴가 부여현황 연도별 (입사일기준 연도별 제외)
// 세무사 상담 우선 적용 필요
